import React, { useState } from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

import DataTable from '../../../components/DataTable';
import Badge from '../../../components/Badge';
import Button from '../../../components/Button';
import Modal from '../../../components/Shell/Modal';
import { TemplateReactSelect } from '../../../components/Attributes/Attributes_old';
import { FIELD_OPTIONS } from '../../../components/helpers/constants';
import { capitalizeFirstLetter } from '../../../components/helpers/functions';

import useAsync from '../../../hooks/useAsync';

import { updateModuleFieldActive } from '../../../api/modules';

const Fields = ({ module, onRefresh }) => {
	const [addfieldOpen, setAddFieldOpen] = useState(null);

	const availableFields = module?.attribute_fields?.filter(
		(field) => !field?.isActive
	);

	const formFields = module?.attribute_fields
		?.filter((field) => field?.isActive)
		.sort((a, b) => a.order - b.order);

	const { execute: onSetFieldActive } = useAsync(updateModuleFieldActive, {
		immediate: false,
	});

	const FIELD_COLUMNS = [
		{
			header: 'Label',
			accessorKey: 'label',
			cell: (info) => {
				return (
					(
						<div>
							{info.getValue()}
							<span className="text-gray-400 text-xxs font-normal">
								{info?.row?.original?.isDefault ? ' - Default' : ''}
							</span>
						</div>
					) || null
				);
			},
		},
		{
			header: 'Key',
			accessorKey: 'key',
			cell: (info) => {
				return (
					(
						<Badge isBeta size={'xxs'}>
							{info.getValue()}
						</Badge>
					) || null
				);
			},
		},
		{
			header: 'Type',
			accessorKey: 'type',
			cell: (info) => {
				return FIELD_OPTIONS.find((o) => o.value === info.getValue())?.label ||
					info.getValue()
					? capitalizeFirstLetter(info.getValue())
					: null;
			},
		},
		{
			header: 'Required',
			accessorKey: 'isRequired',
			cell: (info) => {
				return info?.row?.original?.isRequired ? (
					<CheckIcon className="w-3 h-3 text-green-600" />
				) : (
					'' || null
				);
			},
			enableSorting: false,
		},
		{
			header: 'Searchable',
			accessorKey: 'isSearchable',
			cell: (info) => {
				return info.getValue() ? (
					<CheckIcon className="w-3 h-3 text-green-600" />
				) : (
					'' || null
				);
			},
			enableSorting: false,
		},
		{
			header: '',
			accessorKey: 'accessor',
			cell: (info) => {
				return info?.row?.original?.isDefault ? (
					''
				) : (
					<span
						className="cursor-pointer text-xs"
						onClick={() => {
							onSetFieldActive(
								{
									id: module?.id,
									fieldId: info?.row?.original?.id,
									active: false,
								},
								() => {
									onRefresh({ id: module?.id }, null, { silent: true });
								}
							);
						}}
					>
						Remove
					</span>
				);
			},
			enableSorting: false,
		},
	];

	return (
		<>
			<div className="space-y-5">
				<DataTable
					columns={FIELD_COLUMNS}
					data={{ rows: formFields || [] }}
					usePagination={false}
					useExport={false}
					hasCheckboxes={false}
					manualSorting={false}
					useSearch={false}
					/*titleActions={[
    {
        label: 'Add Field to Form',
        onClick: () => setAddFieldOpen(true),
        type: 'secondary',
    },
]}*/
				/>

				<div className="flex justify-end">
					<Button type="secondary" onClick={() => setAddFieldOpen(true)}>
						Add Field
					</Button>
				</div>
			</div>

			<Modal
				title="Add field to data structure"
				open={addfieldOpen}
				onClose={() => setAddFieldOpen(false)}
			>
				<TemplateReactSelect
					options={availableFields?.map((field) => ({
						label: field?.label,
						value: field?.id,
					}))}
					onChange={(index, value) => {
						onSetFieldActive(
							{
								id: module?.id,
								fieldId: value?.value,
								active: true,
							},
							() => {
								onRefresh({ id: module?.id }, null, { silent: true });
								setAddFieldOpen(false);
							}
						);
					}}
				/>
			</Modal>
		</>
	);
};

export default Fields;
